
export default {
  name: 'MoleculeProjectSliderBackground'
}
